import type { IconData } from '@stacksjs/iconify-core'

export const smileyF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M10 20.858c-5.523 0-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10s-4.477 10-10 10m-3.92-6.606a4.264 4.264 0 0 0 7.84 0a1 1 0 1 0-1.84-.788a2.264 2.264 0 0 1-4.16 0a1 1 0 1 0-1.84.788M7 6.858a1 1 0 0 0-1 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1-1m6 0a1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-2a1 1 0 0 0-1-1\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default smileyF
